module.exports = __webpack_public_path__ + "img/bannerBg.efaa0d6f.png";